import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Search from './Search'

export const SearchSwitcher = (props) => {

    if(props.searchQuery){
        return <Search query={props.searchQuery}/>
    }

    return <CategoryList/>

}

export const CategoryList = () => {

  const html = document.getElementsByTagName("html")[0];
  useEffect(() => {
      html.classList.remove("bg-gray-100")
  
    html.classList.add("bg-white")
  }, [])
    const collections = [
        {
          name: "OEM & Aftermarket Parts",
          description: "Originale und Aftermarketparts in neuem oder gebrauchten Zustand.",
          href: 'parts',
          imageSrc: 'https://images.pexels.com/photos/239419/pexels-photo-239419.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
          imageAlt: 'OEM Parts',
        },
        {
          name: "Bikes & Rolling Chassis",
          description: "Alles was rollt, Original oder modifiziert.",
          href: 'bikes',
          imageSrc: 'https://images.pexels.com/photos/2611686/pexels-photo-2611686.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
          imageAlt: 'Bikes Rolling Chassis',
        },
        {
          name: 'Suchanfragen',
          description: "Diese Parts werden gesucht, vielleicht liegen Sie in deinem Lager.",
          href: 'suchanfragen',
          imageSrc: 'https://cdn.pixabay.com/photo/2018/11/04/20/21/harley-davidson-3794909_960_720.jpg',
          imageAlt: 'Suchanfragen',
        },
      ]

    return(
        <div className='mx-auto grid max-w-md grid-cols-1 gap-y-6 px-4 sm:max-w-7xl sm:grid-cols-3 sm:gap-y-0 sm:gap-x-6 sm:px-6 lg:gap-x-8 lg:px-8'>
        {collections.map((collection) => (
            <div
              key={collection.name}
              className="group relative h-96 rounded-lg bg-white shadow-xl sm:aspect-w-4 sm:aspect-h-5 sm:h-auto"
            >
              <div>
                <div aria-hidden="true" className="absolute inset-0 overflow-hidden rounded-lg">
                  <div className="absolute inset-0 overflow-hidden group-hover:opacity-25">
                    <img
                      src={collection.imageSrc}
                      alt={collection.imageAlt}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-50" />
                </div>
                <div className="absolute inset-0 flex items-end rounded-lg p-6">
                  <div>
                    <p aria-hidden="true" className="text-sm text-white">
                      Durchsuchen
                    </p>
                    <h3 className="mt-1 font-semibold text-white">
                      <Link to={`${collection.href}`}>
                        <span className="absolute inset-0" />
                        {collection.name}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
          </div>
    )
}

function FrontPage() {

    const [searchQuery, setSearchQuery] = useState("")
    const [heading, setHeading] = useState(<span className=''><strong>D</strong>ealers <strong>O</strong>nly <strong>P</strong>arts <strong>E</strong>-Commerce</span>)
    const [padding, setPadding] = useState('py-36')
    const year = new Date()
    const y = year.getFullYear()


    // useEffect(() => {
      
    //     return <SearchSwitcher searchQuery={searchQuery}/>
    
    // }, [searchQuery])
    


  return (
    <main>
        {/* Hero section */}
        <div className="bg-white z-30">
      <div className="mx-auto max-w-7xl px-6 py-8 sm:py-10 lg:flex lg:items-center lg:justify-between lg:px-8">
        <h3 className="text-1xl font-bold tracking-tight text-gray-900 sm:text-2xl">
          Parts, Bikes und Gesuche einstellen
        </h3>
        <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
          <Link
            to="../listings/new"
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Part einstellen
          </Link>
          {/* <button type='button' className="text-sm font-semibold leading-6 text-gray-900">
            Shop durchsuchen <span aria-hidden="true">→</span>
          </button> */}
        </div>
      </div>
    </div>
        <div className="relative">
          {/* Background image and overlap */}
          
          <div aria-hidden="true" className="absolute inset-0 hidden sm:flex sm:flex-col">
            <div className="relative w-full flex-1 bg-gray-900">
              <div className="absolute inset-0 overflow-hidden">
                <img
                  src="https://cdn.pixabay.com/photo/2018/11/04/18/11/motorcycle-3794594_960_720.jpg"
                  alt=""
                  className="h-full w-full object-cover object-center"
                />
              </div>
              <div className="absolute inset-0 bg-gray-400 opacity-70" />
            </div>
            <div className="h-32 w-full bg-white md:h-40 lg:h-48" />
          </div>

          <div className="relative mx-auto max-w-3xl px-4 pb-96 text-center sm:px-6 sm:pb-0 lg:px-8">
            {/* Background image and overlap */}
            <div aria-hidden="true" className="absolute inset-0 flex flex-col sm:hidden">
              <div className="relative w-full flex-1 bg-gray-900">
                <div className="absolute inset-0 overflow-hidden">
                  <img
                    src="https://cdn.pixabay.com/photo/2018/11/04/18/11/motorcycle-3794594_960_720.jpg"
                    alt=""
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="absolute inset-0 bg-gray-400 opacity-70" />
              </div>
              <div className="h-48 w-full bg-white" />
            </div>
            <div id="search" className={`relative ${padding}`}>
              <h2 className="text-4xl font-base tracking-tight text-white sm:text-5xl">{heading}</h2>
              
              <div className="bg-white shadow sm:rounded-lg mt-5">
                <div className="px-4 py-5 sm:p-6">
                    <form className="sm:flex items-center">
                    <div className="w-full">
                        <label htmlFor="parts" className="sr-only">
                        Parts suchen
                        </label>
                        <input
                        type="text"
                        name="text"
                        id="parts"
                        onChange={(e)=>{setSearchQuery(e.target.value); e.target.value ? setHeading("Suche") : setHeading("Dealers Only Parts E-Commerce"); e.target.value ? setPadding("py-12") : setPadding("py-36")}}
                        value={searchQuery}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        placeholder="OEM 123456789"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={searchQuery ? ()=>{setSearchQuery("");setHeading(<span><strong>D</strong>ealers <strong>O</strong>nly <strong>P</strong>arts <strong>E</strong>-Commerce</span>);setPadding("py-36")} : false}
                        disabled={searchQuery ? false : true}
                        className="mt-3 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 max-w-max sm:text-sm"
                    >
                        { !searchQuery ? "Parts suchen" : "Zurück zur Startseite"}
                    </button>
                    </form>
                </div>
                </div>
            </div>
          </div>

          <section aria-labelledby="collection-heading" className="relative -mt-96 sm:mt-0">
            <h2 id="collection-heading" className="sr-only">
              Kategorien
            </h2>
                <SearchSwitcher searchQuery={searchQuery} />  
          </section>
        </div>
        <footer aria-labelledby="footer-heading" className="bg-white">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div >
            <div className="pt-16 pb-20">
              
              <div className="mx-auto mt-16 max-w-5xl xl:grid xl:grid-cols-2 xl:gap-8">
                <div className="grid grid-cols-2 gap-8 xl:col-span-2">
                  <div className="space-y-12 md:grid md:grid-cols-2 md:gap-8 md:space-y-0">
                    
                    
                  </div>
                  <div className="space-y-12 md:grid md:grid-cols-2 md:gap-8 md:space-y-0">
                    
                    
                  </div>
                </div>
              </div>
            </div>

           
          </div>

          <div className="py-10 md:flex md:items-center md:justify-between">
            <div className="text-center md:text-left">
              <p className="text-sm text-gray-500">&copy; {y} Abu-Jo Trading - Alle Rechte vorbehalten</p>
            </div>

            <div className="mt-4 flex items-center justify-center md:mt-0">
              

             
            </div>
          </div>
        </div>
      </footer>
      </main>
  )
}

export default FrontPage